export default __webpack_public_path__ + "static/Linux-4a73721bc7ae9c59a1566075e5e7d4fa.webp";